interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  ariaLabel?: string;
}

/**
 * Minimal inline SVG sparkline. No deps.
 * Handles empty/flat data gracefully.
 */
export function Sparkline({
  values,
  width = 100,
  height = 36,
  ariaLabel = "sparkline",
}: SparklineProps) {
  if (values.length === 0) {
    return (
      <svg
        className="sparkline"
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
        role="img"
        aria-label={`${ariaLabel} (no data)`}
        data-testid="sparkline-empty"
      />
    );
  }

  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;
  const step = values.length > 1 ? width / (values.length - 1) : width;

  const points = values
    .map((v, i) => {
      const x = i * step;
      const y = height - ((v - min) / range) * (height - 4) - 2;
      return `${x.toFixed(2)},${y.toFixed(2)}`;
    })
    .join(" ");

  return (
    <svg
      className="sparkline"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      role="img"
      aria-label={ariaLabel}
      data-testid="sparkline"
    >
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        points={points}
      />
    </svg>
  );
}
